export default __webpack_public_path__ + "static/media/Role_mm.4a956aca.png";